import script from "./ButtonWithIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonWithIcon.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonWithIcon.vue?vue&type=style&index=0&id=2e47d2b5&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e47d2b5"]])

export default __exports__